"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
// This file has been auto-generated. Do not modify directly!
const theme = {
  colors: {
    maple: '#ed5153',
    'maple-100': '#fee3e3',
    'maple-200': '#b93435',
    'maple-300': '#872525',
    dive: '#232a3b',
    'dive-100': '#3c7797',
    'dive-200': '#32637e',
    'dive-300': '#34495e',
    night: '#0c0d0d',
    'night-100': '#383d3d',
    'night-200': '#212424',
    'night-300': '#181a1a',
    snow: '#fff',
    'snow-100': '#fcfcfc',
    'snow-200': '#f3f3f3',
    'snow-300': '#e1e4e5',
    blue: '#2875c6',
    'blue-100': '#e9fafe',
    'blue-200': '#5187e0',
    'blue-300': '#1d5794',
    green: '#35b858',
    'green-100': '#e0f8e6',
    'green-200': '#3dd164',
    'green-300': '#26853f',
    orange: '#e69524',
    'orange-100': '#fdebd0',
    'orange-200': '#f39c26',
    'orange-300': '#996318',
    yellow: '#f1f326',
    'yellow-100': '#fdfcd4',
    'yellow-200': '#ecde36',
    'yellow-300': '#9e941f',
    gray: '#494c4c',
    'gray-100': '#c4cacc',
    'gray-200': '#abb3b3',
    'gray-300': '#848a8a',
    seal: '#737883',
    'seal-100': '#9ba0ab',
    'seal-200': '#505765',
    'seal-300': '#393f4c',
    primary: '#35b858',
    secondary: '#2875c6',
    danger: '#ed5153',
    warning: '#e69524',
    white: '#fff',
    textBody: '#494c4c',
    textHeading: '#0c0d0d',
    textDimmed: '#848a8a',
    disabled: '#e1e4e5',
    dimmed: '#f3f3f3',
    bodyBg: '#f2f5f8'
  },
  breakpoints: ['601px', '1024px'],
  fontFamily: {
    serif: 'serif',
    'sans-serif': 'Lato, Helvetica Neue, Helvetica, Arial, sans-serif',
    monospace: 'monospace'
  },
  space: [0, '0.375rem', '0.75rem', '1.125rem', '1.5rem', '1.875rem', '2.25rem', '2.625rem', '3rem', '3.375rem', '3.75rem'],
  lineHeights: [0, '0.375rem', '0.75rem', '1.125rem', '1.5rem', '1.875rem', '2.25rem', '2.625rem', '3rem', '3.375rem', '3.75rem'],
  fontSizes: {
    'text-xxl': '2.25rem',
    'text-xl': '1.5rem',
    'text-l': '1.125rem',
    text: '1rem',
    'text-s': '0.875rem',
    'text-xs': '0.75rem',
    'text-xxs': '0.5rem',
    xxlarge: '2.25rem',
    xlarge: '1.5rem',
    large: '1.125rem',
    '': '1rem',
    small: '0.875rem',
    xsmall: '0.75rem',
    xxsmall: '0.5rem'
  },
  fontWeights: {
    regular: '400',
    bold: '700'
  },
  letterSpacings: ['normal', '0.03125rem', '0.0625rem', '0.09375rem'],
  shadows: ['0 0.0625rem 0.125rem rgba(12, 13, 13, 0.15)', '0 0.125rem 0.25rem rgba(12, 13, 13, 0.15)', '0 0.1875rem 0.375rem rgba(12, 13, 13, 0.15)', '0 0.375rem 0.75rem rgba(12, 13, 13, 0.15)', '0 0.75rem 1.5rem rgba(12, 13, 13, 0.15)'],
  innerShadows: ['inset 0 0.0625rem 0.125rem rgba(56, 61, 61, 0.1)', 'inset 0 0 0.375rem rgba(12, 13, 13, 0.18)'],
  innerShadowsN: ['inset 0 -0.0625rem 0.1875rem rgba(12, 13, 13, 0.18)'],
  borderShadows: ['0 0 0 0.0625rem rgba(12, 13, 13, 0.15)'],
  radii: {
    'radius-1': '0.1875rem',
    'radius-2': '0.375rem',
    'radius-circle': '50%'
  },
  transition: {
    'transition-duration-fast': '100ms',
    'transition-duration-base': '200ms',
    'transition-duration-slow': '300ms'
  },
  alertVariants: {
    success: {
      background: '#e0f8e6',
      borderColor: '#26853f',
      '.fl-alert__icon svg': {
        fill: 'primary'
      }
    },
    info: {
      background: '#e9fafe',
      borderColor: '#2875c6',
      '.fl-alert__icon svg': {
        fill: 'secondary'
      }
    },
    danger: {
      background: '#fee3e3',
      borderColor: '#b93435',
      '.fl-alert__icon svg': {
        fill: 'danger'
      }
    },
    warning: {
      background: '#fdebd0',
      borderColor: '#e69524',
      '.fl-alert__icon svg': {
        fill: 'warning'
      }
    }
  },
  alertInCardVariants: {
    success: {
      bg: 'green-100',
      borderColor: 'green-300',
      '.fl-alert__icon svg': {
        fill: 'primary'
      }
    },
    info: {
      bg: 'blue-100',
      borderColor: 'blue',
      '.fl-alert__icon svg': {
        fill: 'secondary'
      }
    },
    danger: {
      bg: 'maple-100',
      borderColor: 'maple-200',
      '.fl-alert__icon svg': {
        fill: 'danger'
      }
    },
    warning: {
      bg: 'orange-100',
      borderColor: 'orange',
      '.fl-alert__icon svg': {
        fill: 'orange'
      }
    }
  },
  badgeVariants: {
    default: {
      backgroundColor: '#abb3b3',
      color: '#0c0d0d'
    },
    success: {
      backgroundColor: '#35b858',
      color: '#fff'
    },
    warning: {
      backgroundColor: '#f39c26',
      color: '#494c4c'
    },
    danger: {
      backgroundColor: '#b93435',
      color: '#fff'
    },
    info: {
      backgroundColor: '#5187e0',
      color: '#fff'
    },
    important: {
      backgroundColor: '#2875c6',
      color: '#fff'
    }
  },
  nextBadgeVariants: {
    danger: {
      bg: 'maple-100',
      borderColor: 'maple'
    },
    default: {
      bg: 'gray-100',
      borderColor: 'gray'
    },
    primary: {
      bg: 'blue-100',
      borderColor: 'blue'
    },
    success: {
      bg: 'green-100',
      borderColor: 'green'
    },
    warning: {
      bg: 'orange-100',
      borderColor: 'orange'
    }
  },
  buttonVariants: {
    fill: {
      primary: {
        backgroundImage: 'linear-gradient(to bottom, #3dd164, #35b858)',
        backgroundColor: '#35b858',
        borderColor: '#26853f',
        color: '#fff',
        '&:hover': {
          backgroundImage: 'none',
          color: '#fff',
          backgroundColor: '#35b858',
          borderColor: 'rgba(12,13,13,0.5)'
        },
        '&:active': {
          backgroundImage: 'none',
          color: '#fff',
          backgroundColor: '#33b054',
          boxShadow: 'inset 0 1px 0 0 rgba(38,133,63,0.4)',
          borderColor: 'rgba(12,13,13,0.5)'
        }
      },
      secondary: {
        backgroundImage: 'linear-gradient(to bottom, #5187e0, #2875c6)',
        backgroundColor: '#2875c6',
        borderColor: '#1d5794',
        color: '#fff',
        '&:hover': {
          color: '#fff',
          backgroundImage: 'none',
          backgroundColor: '#2875c6',
          borderColor: 'rgba(12,13,13,0.5)'
        },
        '&:active': {
          color: '#fff',
          backgroundImage: 'none',
          backgroundColor: '#2468b1',
          boxShadow: 'inset 0 1px 0 0 rgba(38,133,63,0.4)',
          borderColor: 'rgba(12,13,13,0.5)'
        }
      },
      danger: {
        backgroundImage: 'linear-gradient(to bottom, #ed5153, #b93435)',
        backgroundColor: '#b93435',
        borderColor: '#872525',
        color: '#fff',
        '&:hover': {
          color: '#fff',
          backgroundImage: 'none',
          backgroundColor: '#b93435',
          borderColor: 'rgba(12,13,13,0.5)'
        },
        '&:active': {
          color: '#fff',
          backgroundImage: 'none',
          backgroundColor: '#a52e2f',
          boxShadow: 'inset 0 1px 0 0 rgba(38,133,63,0.4)',
          borderColor: 'rgba(12,13,13,0.5)'
        }
      },
      neutral: {
        backgroundImage: 'linear-gradient(to bottom, #fff, #f3f3f3)',
        backgroundColor: '#f3f3f3',
        borderColor: '#c4cacc',
        color: '#494c4c',
        '&:hover': {
          color: '#494c4c',
          backgroundImage: 'none',
          backgroundColor: '#f3f3f3',
          borderColor: '#abb3b3'
        },
        '&:active': {
          color: '#494c4c',
          backgroundImage: 'none',
          backgroundColor: '#f3f3f3',
          boxShadow: 'rgba(12, 13, 13, 0.18) 0px 0px 0.375rem inset',
          borderColor: '#abb3b3'
        }
      }
    },
    outline: {
      primary: {
        color: '#35b858',
        backgroundImage: 'linear-gradient(to bottom, #fff 38%, #e0f8e6 205%)',
        borderColor: '#35b858',
        '&:hover': {
          backgroundColor: '#e0f8e6',
          color: '#26853f',
          boxShadow: 'none',
          backgroundImage: 'none'
        },
        '&:active': {
          backgroundImage: 'none',
          backgroundColor: '#e0f8e6',
          color: '#26853f',
          boxShadow: 'inset 0 0 0.375rem rgba(38,133,63,0.4)'
        }
      },
      secondary: {
        color: '#2875c6',
        backgroundImage: 'linear-gradient(to bottom, #fff 38%, #e9fafe 138%)',
        borderColor: '#2875c6',
        '&:hover': {
          backgroundColor: '#e9fafe',
          color: '#1d5794',
          boxShadow: 'none',
          backgroundImage: 'none'
        },
        '&:active': {
          backgroundImage: 'none',
          backgroundColor: '#e9fafe',
          color: '#1d5794',
          boxShadow: 'inset 0 0 0.375rem rgba(29,87,148,0.4)'
        }
      },
      danger: {
        color: '#b93435',
        backgroundImage: 'linear-gradient(to bottom, #fff 38%, #fee3e3 220%)',
        borderColor: '#b93435',
        '&:hover': {
          backgroundColor: '#fee3e3',
          color: '#872525',
          boxShadow: 'none',
          backgroundImage: 'none'
        },
        '&:active': {
          backgroundImage: 'none',
          backgroundColor: '#fee3e3',
          color: '#872525',
          boxShadow: 'inset 0 0 0.375rem rgba(135,37,37,0.4)'
        }
      }
    }
  },
  buttonIconVariants: {
    fill: {
      primary: {
        fill: '#fff',
        color: '#35b858',
        '.cr-icon__details-2': {
          color: '#35b858',
          fill: '#35b858'
        }
      },
      secondary: {
        fill: '#fff',
        color: '#2875c6',
        '.cr-icon__details-2': {
          color: '#2875c6',
          fill: '#2875c6'
        }
      },
      danger: {
        fill: '#fff',
        color: '#ed5153',
        '.cr-icon__details-2': {
          color: '#ed5153',
          fill: '#ed5153'
        }
      },
      neutral: {
        fill: '#494c4c',
        color: '#fff',
        '.cr-icon__details-2': {
          color: '#fff',
          fill: '#fff'
        }
      }
    },
    outline: {
      primary: {
        fill: '#35b858',
        color: '#e0f8e6'
      },
      secondary: {
        fill: '#2875c6',
        color: '#e9fafe'
      },
      danger: {
        fill: '#b93435',
        color: '#fee3e3'
      },
      neutral: {
        fill: '#494c4c',
        color: '#fff'
      }
    }
  },
  cardStyles: {
    background: '#fff',
    header: {
      border: '#e1e4e5'
    },
    footer: {
      border: '#e1e4e5'
    }
  },
  cardVariants: {
    neutral: {
      boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.06), 0 3px 6px 0 rgba(0, 0, 0, 0.03), 0 1px 2px 0 rgba(0, 0, 0, 0.1)'
    },
    top: {
      boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.06), 0 6px 12px 0 rgba(0, 0, 0, 0.03), 0 4px 8px 0 rgba(0, 0, 0, 0.08)'
    }
  },
  checkboxStyles: {
    background: 'linear-gradient(180deg, #fff, #f3f3f3)',
    borderColor: '#abb3b3',
    color: '#fff',
    focus: {
      boxShadow: ' 0 0 0 1px #fff, 0 0 0 3px #2875c6'
    },
    indeterminate: {
      border: '#2875c6',
      background: '#1d5794'
    },
    checked: {
      background: '#2875c6',
      border: '#1d5794',
      color: '#fff'
    },
    label: {
      color: '#0c0d0d'
    },
    description: {
      color: '#848a8a'
    }
  },
  dividerStyles: {
    color: '#c4cacc',
    cardColor: '#e1e4e5'
  },
  inputStyles: {
    background: '#fff',
    color: '#494c4c',
    border: '#c4cacc',
    boxShadow: 'inset 0 0.0625rem 0.125rem rgba(56, 61, 61, 0.1)',
    placeholder: {
      color: '#abb3b3'
    },
    hover: {
      border: '#9ba0ab'
    },
    active: {
      border: '#2875c6'
    },
    disabled: {
      color: '#848a8a',
      background: '#f3f3f3'
    },
    focus: {
      border: '#2875c6'
    },
    helper: {
      background: '#848a8a'
    },
    warning: {
      color: '#e69524'
    },
    error: {
      border: '#b93435',
      color: '#b93435'
    },
    valid: {
      color: '#35b858'
    },
    readonly: {
      color: '#494c4c',
      background: '#f3f3f3'
    },
    label: {
      color: '#0c0d0d'
    },
    autofilled: {
      background: '#fdfcd4',
      color: '#0c0d0d'
    },
    autocomplete: {
      border: '#abb3b3',
      controlDropdownIndicator: {
        color: '#848a8a'
      },
      controlHover: {
        border: '#848a8a'
      },
      indicator: {
        color: '#848a8a'
      },
      optionSelected: {
        background: '#f3f3f3',
        color: '#0c0d0d'
      },
      multiValue: {
        color: '#2875c6',
        background: 'rgba(40,117,198,0.08)',
        backgroundDisabled: '#fcfcfc',
        border: 'rgba(40,117,198,0.24)',
        borderDisabled: '#e1e4e5'
      },
      multiValueLabel: {
        color: '#2875c6',
        colorDisabled: '#383d3d'
      },
      multiValueRemove: {
        color: '#2875c6',
        colorDisabled: '#0c0d0d'
      }
    }
  },
  logoVariants: {
    flame: {
      default: {
        fill: '#ed5153'
      },
      'red-white': {
        fill: '#ed5153'
      },
      dive: {
        fill: '#232a3b'
      },
      night: {
        fill: '#0c0d0d'
      },
      snow: {
        fill: '#fff'
      },
      maple: {
        fill: '#ed5153'
      }
    },
    word: {
      default: {
        fill: '#0c0d0d'
      },
      'red-white': {
        fill: '#fff'
      },
      dive: {
        fill: '#232a3b'
      },
      night: {
        fill: '#0c0d0d'
      },
      snow: {
        fill: '#fff'
      },
      maple: {
        fill: '#ed5153'
      }
    }
  },
  radioStyles: {
    background: '#fff linear-gradient(180deg, #fff, #f3f3f3)',
    border: '#abb3b3',
    color: '#fff',
    focus: {
      boxShadow: '0 0 0 1px #fff, 0 0 0 3px #2875c6'
    },
    checked: {
      background: '#2875c6',
      border: '#1d5794'
    },
    description: {
      color: '#848a8a'
    },
    label: {
      color: '#0c0d0d'
    }
  },
  selectStyles: {
    backgroundColor: '#fff',
    background: 'linear-gradient(180deg, #fff, #f3f3f3)',
    border: '#c4cacc',
    color: '#494c4c',
    focusBorder: '#2875c6',
    disabledColor: '#848a8a',
    disabledBackground: '#f3f3f3'
  },
  switchStyles: {
    on: {
      background: '#2875c6',
      border: '#1d5794',
      color: '#fff',
      focusBorder: '#1d5794',
      errorBorder: '#b93435',
      checkedBorder: '#1d5794'
    },
    off: {
      background: '#fff',
      border: '#abb3b3',
      color: '#848a8a'
    },
    slider: {
      border: '#abb3b3',
      background: '#fff',
      shadow: '0 0.1875rem 0.375rem rgba(12, 13, 13, 0.15)'
    },
    icons: {
      checkmarkBackground: '#fff',
      crossBackground: '#848a8a'
    }
  },
  tagStyles: {
    main: {
      background: '#2875c6',
      hoverBackground: '#5187e0',
      activeBackground: '#1d5794',
      focusBorder: '#2875c6',
      color: '#fff',
      boxShadow: '0 0 0 0.0625rem #fff, 0 0 0 0.1875rem #2875c6, inset 0 0 0.375rem rgba(12, 13, 13, 0.18)'
    },
    remove: {
      background: '#2875c6',
      hoverBackground: '#5187e0',
      activeBackground: '#1d5794',
      icon: {
        background: 'rgba(12,13,13,0.4)',
        details: '#fff',
        hoverBackground: 'rgba(12,13,13,0.65)',
        focusBackground: 'rgba(12,13,13,0.4)',
        focusBoxShadow: '0 0 0 0.0625rem transparent, 0 0 0 0.125rem #fff',
        activeBackground: 'rgba(12,13,13,0.2)'
      }
    }
  },
  tooltipStyles: {
    light: {
      background: '#f3f3f3',
      border: '#abb3b3',
      shadow: '0 0.125rem 0.25rem rgba(12, 13, 13, 0.15)',
      color: '#494c4c'
    },
    dark: {
      background: '#494c4c',
      border: '#494c4c',
      shadow: '0 0.125rem 0.25rem rgba(12, 13, 13, 0.15)',
      color: '#fff'
    }
  },
  modalStyles: {
    overlay: {
      background: 'rgba(12,13,13,0.8)'
    },
    modal: {
      background: '#fff',
      color: '#494c4c'
    },
    header: {
      border: '#c4cacc',
      color: '#181a1a'
    },
    footer: {
      background: '#f3f3f3',
      border: '#c4cacc'
    }
  },
  progressStyles: {
    background: '#e1e4e5',
    progressBar: {
      background: '#2875c6 \nlinear-gradient(\n  45deg,\n  #2875c6 0%,\n  #82e9ff 25%,\n  #2875c6 75%,\n  #82e9ff 100%\n)\n',
      backgroundSize: '400% 400%'
    },
    progressBarStatic: {
      background: '#2875c6'
    }
  },
  popoverStyles: {
    boxShadow: '0 0 0 0.0625rem rgba(12, 13, 13, 0.15), 0 0.1875rem 0.375rem rgba(12, 13, 13, 0.15)',
    arrowColor: 'rgba(12,13,13,0.15)',
    light: {
      background: '#fff'
    },
    dark: {
      background: '#f3f3f3'
    }
  },
  textStyles: {
    color: '#0c0d0d',
    link: {
      color: '#2875c6'
    }
  },
  boneStyles: {
    background: '#e1e4e5'
  },
  groupStyles: {
    addon: {
      background: '#f3f3f3',
      borderColor: '#abb3b3'
    }
  },
  wordmarkStyles: {
    border: '#ed5153',
    light: {
      color: '#fff'
    },
    dark: {
      color: '#0c0d0d'
    }
  },
  tableStyles: {
    progress: {
      background: 'linear-gradient(\n  45deg,\n  #2875c6 0%,\n  #82e9ff 25%,\n  #2875c6 75%,\n  #82e9ff 100%\n)',
      backgroundSize: '400% 400%',
      loadingBackground: '#e1e4e5'
    },
    tr: {
      hover: {
        background: '#f5fdff'
      },
      borderColor: '#e1e4e5'
    },
    dropdown: {
      hover: {
        background: '#f3f3f3'
      }
    },
    sortable: {
      button: {
        background: 'rgba(40,117,198,0.1)'
      }
    }
  },
  sidebarStyles: {
    background: '#232a3b',
    borderColor: '#505765',
    iconDetails: '#232a3b',
    header: {
      color: '#494c4c'
    },
    menulink: {
      normal: {
        color: '#2875c6'
      },
      danger: {
        color: '#b93435'
      }
    },
    lockButton: {
      borderColor: '#505765'
    }
  },
  npsStyles: {
    text: {
      dimmed: '#9ba0ab'
    }
  },
  toasterVariants: {
    success: {
      '.fl-toaster__container': {
        bg: 'green-100'
      },
      '.fl-toaster__countdown': {
        bg: 'primary'
      },
      '.fl-toaster__dismiss-btn svg': {
        fill: 'gray-300'
      },
      '.fl-toast__action-btn': {
        color: 'blue-300'
      }
    },
    error: {
      '.fl-toaster__container': {
        bg: 'maple-100'
      },
      '.fl-toaster__countdown': {
        bg: 'danger'
      },
      '.fl-toaster__dismiss-btn svg': {
        fill: 'gray-300'
      },
      '.fl-toast__action-btn': {
        color: 'blue-300'
      }
    }
  }
};
exports.theme = theme;